import web from "@/core/middlewares/web";

let communitiesIndex = () => import(/* webpackChunkName: "communities" */ '@/views/communities/Index');
let communitiesCreate = () => import(/* webpackChunkName: "communities" */ '@/views/communities/Create');
let communitiesEdit = () => import(/* webpackChunkName: "communities" */ '@/views/communities/Edit');
let organizationsIndex = () => import(/* webpackChunkName: "organizations" */ '@/views/communities/organizations/Index');
let organizationsCreate = () => import(/* webpackChunkName: "organizations" */ '@/views/communities/organizations/Create');
let organizationsEdit = () => import(/* webpackChunkName: "organizations" */ '@/views/communities/organizations/Edit');
let subnetworks = () => import(/* webpackChunkName: "activity-fields" */ '@/views/communities/sub-networks/Index');
let serviceScopes = () => import(/* webpackChunkName: "activity-fields" */ '@/views/communities/service-scopes/Index');
let productsIndex = () => import(/* webpackChunkName: "products" */ '@/views/communities/organizations/products/Index');
let productsCreate = () => import(/* webpackChunkName: "products" */ '@/views/communities/organizations/products/Create');
let productsEdit = () => import(/* webpackChunkName: "products" */ '@/views/communities/organizations/products/Edit');

export default [
    {
        path: "/communities",
        name: "communities.index",
        component: communitiesIndex,
        meta: {
            middleware: web,
            permissions: ['communities:viewAny'],
            title: "جوامع"
        }
    },
    {
        path: "/communities/create",
        name: "communities.create",
        component: communitiesCreate,
        meta: {
            middleware: web,
            permissions: ['communities:create'],
            title: "ایجاد جوامع"
        }
    },
    {
        path: "/communities/:id",
        name: "communities.edit",
        component: communitiesEdit,
        meta: {
            middleware: web,
            permissions: ['communities:view','communities:update'],
            title: "ویرایش جوامع"
        }
    },
    {
        path: "/community-organizations",
        name: "community-organizations.index",
        component: organizationsIndex,
        meta: {
            middleware: web,
            permissions: ['community-organizations:viewAny'],
            title: "سازمان ها"
        }
    },
    {
        path: "/community-organizations/create",
        name: "community-organizations.create",
        component: organizationsCreate,
        meta: {
            middleware: web,
            permissions: ['community-organizations:create'],
            title: "ایجاد سازمان"
        }
    },
    {
        path: "/community-organizations/:id",
        name: "community-organizations.edit",
        component: organizationsEdit,
        meta: {
            middleware: web,
            permissions: ['community-organizations:view','community-organizations:update'],
            title: "ویرایش سازمان"
        }
    },
    {
        path: "/community-organizations/:organization/products",
        name: "community-organizations.products.index",
        component: productsIndex,
        meta: {
            middleware: web,
            permissions: ['community-organizations:view','community-organizations:update'],
            title: "محصولات سازمان"
        }
    },
    {
        path: "/community-organizations/:organization/products/create",
        name: "community-organizations.products.create",
        component: productsCreate,
        meta: {
            middleware: web,
            permissions: ['community-organizations:update'],
            title: "ایجاد محصول سازمان"
        }
    },
    {
        path: "/community-organizations/:organization/products/:product/edit",
        name: "community-organizations.products.edit",
        component: productsEdit,
        meta: {
            middleware: web,
            permissions: ['community-organizations:update'],
            title: "ویرایش محصول سازمان"
        }
    },
    {
        path: "/sub-networks",
        name: "sub-networks.index",
        component: subnetworks,
        meta: {
            middleware: web,
            permissions: ['sub-networks:viewAny'],
            title: "زیر شبکه ها"
        }
    },
    {
        path: "/community-service-scopes",
        name: "community-service-scopes.index",
        component: serviceScopes,
        meta: {
            middleware: web,
            permissions: ['community-service-scopes:viewAny'],
            title: "محدوده خدمات"
        }
    },
]
